/**
 * 프로모션 배너 표시 기준 일수
 * - 이 일수를 초과하면 플로팅 배너 미노출, 타이머 아이콘 미노출
 */
export const PROMOTION_DISPLAY_THRESHOLD_DAYS = 14;
